import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import '../../shared/base.css';
import './signage.css';

// No router: the signage app is one screen. Whether it shows a pairing code or
// the carousel is a matter of whether this display has been paired, not of a
// URL - a television has no address bar.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
